import "./instrument";
import { createRoot } from "react-dom/client";
import "./main.css";
import App from "./App";
import store from "./store";
import { Provider } from "react-redux";
import { Auth0Provider } from "@auth0/auth0-react";
import "./i18n";
import jssVariables from "./jss_setup";
import * as Sentry from "@sentry/react";
const withAuth = import.meta.env.VITE_APP_PRIVATE_WEBSITE === "true";

const auth0ProviderProps = {};

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <Provider store={store}>
    {withAuth ? (
      <Sentry.ErrorBoundary fallback={<div>Error</div>}>
        <Auth0Provider
          domain={import.meta.env.VITE_APP_AUTH0_DOMAIN}
          clientId={import.meta.env.VITE_APP_AUTH0_CLIENTID}
          useRefreshTokens={true}
          authorizationParams={{
            redirect_uri: `${window.location.origin}/authnavigator`,
            /* redirect_uri: window.location.origin, */
            logo: import.meta.env.VITE_APP_LOGO || "",
            background_img: import.meta.env.VITE_APP_AUTH0_BACKGROUND || "",
            base_color: jssVariables.colors.base_color,
            title: import.meta.env.VITE_APP_AUTH0_TITLE || "",
          }}
          {...auth0ProviderProps}
        >
          <App />
        </Auth0Provider>
      </Sentry.ErrorBoundary>
    ) : (
      <Sentry.ErrorBoundary fallback={<div>Error</div>}>
        <App />
      </Sentry.ErrorBoundary>
    )}
  </Provider>,
);
